var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbeddedtrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#ED3237",
    fillOpacity: 0.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 12.0625L11.1875 13.375L15.5625 9L11.1875 4.625L9.875 5.9375L12.9375 9L9.875 12.0625ZM8.125 5.9375L6.8125 4.625L2.4375 9L6.8125 13.375L8.125 12.0625L5.0625 9L8.125 5.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedtrue);
export default __webpack_public_path__ + "static/media/embeddedtrue.4d0e8fc2bda2cdd99227021aebb90c78.svg";
export { ForwardRef as ReactComponent };